import {
  buildConceptDisplayLogic,
  buildQuestionDisplayLogic,
  DisplayLogic,
  DisplayLogicByResource,
} from './displayLogic'
import { buildTestLabel, hasFeature, QUESTION_TYPES } from './questions'
import { Concept, getConcepts } from './concepts'
import { getRequireViewConceptError } from './requireViewing'
import { sanitizeHtml } from './richText'
import { Question as QuestionAPI } from 'types/glass-api/domainModels'

export type Question = {
  concepts: Concept[]
  constraints: {
    requireConceptView: boolean
  }
  directions: string
  features: {
    conceptDisplayLogic: DisplayLogicByResource
    displayLogic: DisplayLogic
  }
  id: string
  legacyOptionID: number
  response: 'completed' | null
  testing: { label: string }
  title: string
  type: 'ideaPresenter'
}

export function canContinue({ question }: { question: Question }) {
  return !getRequireViewConceptError({ question })
}

export function getDisplayError({ question }: { question: Question }) {
  return question.concepts.length > 0 ? false : 'no concepts'
}

export function getQuestion({
  id,
  question,
}: {
  id: string
  question: QuestionAPI
}) {
  return {
    concepts: getConcepts({ question }),
    constraints: {
      requireConceptView: hasFeature({ code: 'VAL02', question }),
    },
    directions: sanitizeHtml(question.description),
    features: {
      conceptDisplayLogic: buildConceptDisplayLogic({ question }),
      displayLogic: buildQuestionDisplayLogic({ question }),
    },
    id,
    legacyOptionID: question.options[0].id,
    response: null,
    testing: { label: buildTestLabel(question) },
    title: sanitizeHtml(question.title),
    type: 'ideaPresenter' as const,
  } satisfies Question
}

export function isIdeaPresenterQuestion(question: {
  conceptTestMedia: unknown[]
  isMonadicSettings?: boolean
  questionTypeId: number
}) {
  const legacyIdeaPresenter =
    question.questionTypeId === QUESTION_TYPES.MULTIPLE_CHOICE &&
    question.conceptTestMedia &&
    question.conceptTestMedia.length > 1
  if (legacyIdeaPresenter) {
    return true
  }

  return question.isMonadicSettings ?? false
}
